module.exports = __webpack_public_path__ + "./fonts/la-brands-400.ttf";